import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/reports/monthlyDetailReport'
import Component from 'components/Reports/MonthlyDetailReport'

export default createListViewContainer({ actions, selectors: selectors.monthlyDetailReport })(Component)
